import styled, { css } from "styled-components";
import { designTokens } from "../../../../components/ui/foundation/DesignTokens";

export const InputContainer = styled.div`
  margin-bottom: 1.5rem;
  width: 26.75rem;
  height: 26.25rem;
  position: relative;
`;

export const Suggestion = styled.p`
  width: ${(props) => (props.variables ? "100%" : "70%")};
  height: auto;
  min-height: 1.688rem;
  margin-top: 1.375rem;
  margin-bottom: 1.938rem;
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 500;
  font-size: ${designTokens.fontSizes.xs};
  line-height: 150%;
  letter-spacing: -0.32px;
  color: ${designTokens.colors.gray[500]};

  ${(props) =>
    props.variables &&
    css`
      margin-top: 0;
      margin-bottom: 5rem;
    `}
  ${(props) =>
    props.messagePreview &&
    css`
      margin-top: 0.625rem;
      width: 100%;
    `}
`;

export const NewWhatsappTitle = styled.p`
  font-family: ${designTokens.fonts.heading};
  font-style: normal;
  font-weight: 700;
  font-size: ${designTokens.fontSizes.lg};
  line-height: 150%;
  letter-spacing: -0.257238px;
  color: ${designTokens.colors.gray[900]};
`;

export const MessagePreviewContainer = styled.div`
  width: 100%;
  max-width: 26.625rem;
  height: auto;
  position: relative;
  min-height: 50px;
  max-height: 580px;
  background: #e3e3e3;
  border-radius: ${designTokens.radius.md};
  overflow: hidden;
  box-sizing: border-box;
`;

export const MessagePreview = styled.div`
  width: calc(100% - 48px);
  max-width: 100%;
  position: relative;
  margin-left: 32px;
  margin-right: 16px;
  margin-top: 1.563rem;
  background-color: #d9fdd3;
  border-radius: ${designTokens.radius.sm};
  padding: 0.75rem 0.5rem 1.5rem 0.938rem;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  color: ${designTokens.colors.gray[900]};
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  overflow: hidden;
  box-sizing: border-box;

  & > span,
  & span,
  & p,
  & div {
    background-color: #d9fdd3 !important;
    font-family: ${designTokens.fonts.body} !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 0.875rem !important;
    line-height: 150% !important;
    letter-spacing: -0.257238px !important;
    color: ${designTokens.colors.gray[900]} !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    white-space: pre-wrap !important;
    max-width: 100% !important;
  }

  .button-text {
    display: inline-block;
    max-width: 100%;
    word-break: break-word !important;
  }
`;

export const PreviewImageContainer = styled.div`
  width: 95%;
  height: 162px;
  margin-bottom: 0.75rem;
`;

export const ContentSpan = styled.span`
  background-color: #d9fdd3 !important;
  font-family: ${designTokens.fonts.body} !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 150% !important;
  letter-spacing: -0.257238px !important;
  color: ${designTokens.colors.gray[900]} !important;
  padding: 0.5rem !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  white-space: pre-wrap !important;
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  *,
  span,
  p,
  div,
  strong,
  em,
  b,
  i {
    font-family: inherit !important;
    font-size: inherit !important;
    color: inherit !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    white-space: pre-wrap !important;
    max-width: 100% !important;
    display: inline !important;
  }

  .button-text {
    display: block !important;
    text-align: center;
    padding: 8px 12px;
    margin-top: 8px;
    background: rgba(255, 255, 255, 0.5) !important;
    border-radius: 6px;
  }
`;
